export default __webpack_public_path__ + "static/LeftTree-4795f158b42049fef855686679b294ce.svg";